export default function InitSearch() {
    const headerSearchBtn = document.querySelectorAll("[data-search-trigger]");
    const searchOverlayer = document.querySelector(".search-widget .search-overlayer");
    const searchBar = document.querySelector(".search-widget");

    if (headerSearchBtn !== null && searchOverlayer !== null && searchBar !== null) {
        headerSearchBtn.forEach(function (elm) {
            elm.addEventListener("click", function () {
                searchBar.classList.remove("hide");
            });
        });
        searchOverlayer.addEventListener("click", function () {
            searchBar.classList.add("hide");
        });
    }
}